import React, { Fragment } from 'react';

export default function PageContainer(props) {
  return (
    <Fragment>
      {props.children}
    </Fragment>
  );
}
